<div class="outline">
    <ul cdkDropList (cdkDropListDropped)="drop($event)">
        <li *ngFor="let unit of treeData; trackBy: trackByFn"
            id="{{unit.informationUnitId}}"
            class="outline-item-li cursorPointer"
            [class.BUnit]="unit.unitLevel === 'B'"
            [class.CUnit]="unit.unitLevel === 'C'"
            [class.DUnit]="unit.unitLevel === 'D'"
            [class.EAndFUnits]="unit.unitLevel === 'E' || unit.unitLevel === 'F'">
            <p id="{{unit.unitOrder}}" *ngIf="unit.informationUnitTitle && unit.informationUnitTitle !== ''"
               [tabIndex]="0"
               [class.basicLi]="unit.status === 'UNMARKED'"
               [class.activeLi]="unit.unitOrder === currentUnitOrderId"
               [class.boldLi]="unit.unitLevel === 'A'"
               [innerHTML]="stripTagsFromString(unit.informationUnitTitle)"
               [attr.aria-label]="unit.informationUnitTitle"
               (click)="elementClicked(unit)"
               (keyup)="onKeyUp($event, unit)"
               (keydown)="onKeyDown($event)"
               cdkDrag>
                {{unit.informationUnitTitle}}
            </p>
            <p *ngIf="!unit.informationUnitTitle || unit.informationUnitTitle === ''" class="untitled"
               [tabIndex]="0"
               [class.basicLi]="unit.status === 'UNMARKED'"
               [class.activeLi]="unit.unitOrder === currentUnitOrderId"
               [class.boldLi]="unit.unitLevel === 'A'"
               [attr.aria-label]="unit.informationUnitTitle"
               (click)="elementClicked(unit)"
               (keyup)="onKeyUp($event, unit)"
               (keydown)="onKeyDown($event)">
                {{noTitle}}
            </p>
            <div id="{{unit.informationUnitId}}" [class.actionsOnSelected]="unit.unitOrder === currentUnitOrderId" class="action-toolbar">
                <div class="action-toolbar__relevance-dropdown">
                    <div class="action-toolbar__relevance-dropdown">
                        <select class="select" [(ngModel)]="unit.unitRelevance" (ngModelChange)="onChange($event, unit)">
                            <option *ngFor="let option of relevanceList" value="{{option.selectId}}" class="option">
                                {{option.selectValue}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="button-wrapper">
                    <app-button [cssClasses]="'icon wh-32 solid__gray-05'"
                                [icon]="'navigate_before'"
                                [iconSize]="'28'"
                                [disabled]="isLevelUpDisabled(unit)"
                                [hideLabel]="true"
                                (buttonClicked)="unitLevelUpEvent.emit(unit)">
                    </app-button>
                </div>
                <div class="button-wrapper">
                    <app-button [cssClasses]="'icon wh-32 solid__gray-05'"
                                [icon]="'navigate_next'"
                                [iconSize]="'28'"
                                [disabled]="isLevelDownDisabled(unit)"
                                [hideLabel]="true"
                                (buttonClicked)="unitLevelDownEvent.emit(unit)">
                    </app-button>
                </div>
                <div class="button-wrapper">
                    <app-button [cssClasses]="'icon wh-32 solid__red-06'"
                                [iconSize]="'20'"
                                [icon]="'delete'"
                                (buttonClicked)="unitDeleteEvent.emit(unit)">
                        {{'GENERAL.DELETE' | translate}}
                    </app-button>
                </div>
            </div>
        </li>
    </ul>
</div>
